import { render, staticRenderFns } from "./PmdaModal.vue?vue&type=template&id=3190b807&scoped=true&"
import script from "./PmdaModal.vue?vue&type=script&lang=js&"
export * from "./PmdaModal.vue?vue&type=script&lang=js&"
import style0 from "./PmdaModal.vue?vue&type=style&index=0&id=3190b807&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3190b807",
  null
  
)

export default component.exports